function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $component, $helpers, Array, JSON, Object, String, stagedCohort) {
    var h = require("panel").h;
    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }

    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    const literalIdx = $helpers.getLiteralIndex();
    const literal = stagedCohort.literals[literalIdx];
    return {
      value: (h("div", {
        "class": {
          'cohorts-literal-builder': true
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'cohorts-literal-builder-header': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'cohorts-literal-label-container': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(($component.isAttributeEnabled('data-draggable')) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "on": {
                  mousedown: $helpers.onGripperMouseDown,
                  mouseenter: $helpers.onGripperMouseEnter,
                  mouseleave: $helpers.onGripperMouseLeave,
                },
                "class": {
                  'cohorts-literal-gripper': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                  "attrs": __vjadeStringifyAttrsIfObj({
                    icon: `gripper`
                  }),
                }));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this)) : undefined);
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'cohorts-literal-label-text': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat((function() {
                var $$obj = ($helpers.getLiteralLabelParts());
                var $$eachNodes;
                var $$iterated = false;
                if (Array.isArray($$obj)) {
                  $$eachNodes = $$obj.reduce(function($$eachNodes, part, idx) {
                    $$iterated = true;
                    return $$eachNodes.concat((function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("span", {
                        "class": {
                          'cohorts-literal-label-text-operator': !part.literal,
                          'cohorts-literal-add-space': part.precedingSpace,
                        },
                      }, [__vjadeSafeCode(part.text)]));;
                      return __jade_nodes
                    }).call(this));
                  }, []);
                } else {
                  $$eachNodes = [];
                  for (var $$objKey in $$obj) {
                    (function() {
                      var idx = $$objKey;
                      if ($$obj.hasOwnProperty(idx)) {
                        $$iterated = true;
                        var part = $$obj[idx];
                        $$eachNodes = $$eachNodes.concat((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("span", {
                            "class": {
                              'cohorts-literal-label-text-operator': !part.literal,
                              'cohorts-literal-add-space': part.precedingSpace,
                            },
                          }, [__vjadeSafeCode(part.text)]));;
                          return __jade_nodes
                        }).call(this));
                      }
                    })();
                  }
                }

                return $$eachNodes;
              })());;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat((!$attr(`disabled`)) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'cohorts-literal-add-condition': true
              },
            }, (function() {
              var __jade_nodes = [];
              const addConditionDisabledMessage = $helpers.getAddConditionDisabledMessage();
              __jade_nodes = __jade_nodes.concat(h("mp-button", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  icon: `plus`,
                  theme: `tertiary`,
                  disabled: !!addConditionDisabledMessage,
                }),
                "on": {
                  click: $helpers.addClauseToLiteral
                },
                "class": {
                  'cohorts-literal-add-condition-button': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("Condition");;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat((addConditionDisabledMessage) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                  "attrs": __vjadeStringifyAttrsIfObj({
                    placement: `top`,
                    'max-width': '200px'
                  }),
                }, [__vjadeSafeCode(addConditionDisabledMessage)]));;
                return __jade_nodes
              }).call(this)) : undefined);;
              return __jade_nodes
            }).call(this).filter(Boolean))); /*  literals can only be removed when there is more than one present */
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": Object.assign({}, {
                'cohorts-literal-remove-literal-hidden': stagedCohort.numLiterals < 2
              }, {
                'cohorts-literal-remove-literal': true
              }),
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  'max-width': '150px'
                }),
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("span", {
                  "class": {
                    'cohorts-literal-remove-literal-tooltip': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("Remove group");;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat(h("mp-button", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  icon: `trashcan`,
                  theme: `tertiary`,
                  type: `destructive`,
                }),
                "on": {
                  click: $helpers.removeLiteral
                },
              }));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)) : undefined);;
          return __jade_nodes
        }).call(this).filter(Boolean)));
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'cohorts-literal-builder-body': true
          },
        }, (function() {
          var __jade_nodes = [];
          const literalComponentName = $helpers.getLiteralComponentName();
          __jade_nodes = __jade_nodes.concat((function() {
            var $$obj = (literal.clauses);
            var $$eachNodes;
            var $$iterated = false;
            if (Array.isArray($$obj)) {
              $$eachNodes = $$obj.reduce(function($$eachNodes, clause, clauseIdx) {
                $$iterated = true;
                return $$eachNodes.concat((function() {
                  var __jade_nodes = [];
                  const isLastClause = clauseIdx === literal.clauses.length - 1;
                  const literalComponentAttrs = $helpers.getLiteralComponentAttrs(clauseIdx, literalIdx, isLastClause);
                  __jade_nodes = __jade_nodes.concat($component.child(literalComponentName, {
                    attrs: literalComponentAttrs
                  }));;
                  return __jade_nodes
                }).call(this));
              }, []);
            } else {
              $$eachNodes = [];
              for (var $$objKey in $$obj) {
                (function() {
                  var clauseIdx = $$objKey;
                  if ($$obj.hasOwnProperty(clauseIdx)) {
                    $$iterated = true;
                    var clause = $$obj[clauseIdx];
                    $$eachNodes = $$eachNodes.concat((function() {
                      var __jade_nodes = [];
                      const isLastClause = clauseIdx === literal.clauses.length - 1;
                      const literalComponentAttrs = $helpers.getLiteralComponentAttrs(clauseIdx, literalIdx, isLastClause);
                      __jade_nodes = __jade_nodes.concat($component.child(literalComponentName, {
                        attrs: literalComponentAttrs
                      }));;
                      return __jade_nodes
                    }).call(this));
                  }
                })();
              }
            }

            return $$eachNodes;
          })());;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };

  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$component" in locals ? locals.$component : typeof $component !== "undefined" ? $component : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "Array" in locals ? locals.Array : typeof Array !== "undefined" ? Array : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined, "stagedCohort" in locals ? locals.stagedCohort : typeof stagedCohort !== "undefined" ? stagedCohort : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;